<h2 class="title">{{ 'CLAIM_FAQ_1' | translate }}</h2>
<section [multiple]="false">
  <div class="row margin-top mt16 margin-bottom mb8 faq">
    <a  class="mapfre link collapse-link padding-horizontal ph40" (click)="closeNonActiveCollapse('one')" mdbRipple [class.active]="accordianWithMDB.one">
      <div class="row">
        <div class="col">{{ 'CLAIM_FAQ_2' | translate }} </div>
        <div class="col collapse-carot text-right">
          <i class="fas fa-caret-down" *ngIf="!accordianWithMDB.one"></i>
          <i class="fas fa-caret-up" *ngIf="accordianWithMDB.one"></i>
        </div>
      </div>
    </a>
    <div class="row collapse-content padding-horizontal ph40" #one [class.fake-accourdian]="!accordianWithMDB.one">
      <div class="padding-horizontal ph16 w-100">
          This is demo mapfre insturence and participating collapse-content <br>
          <strong>You may have your vehicle repaired:</strong><br>
          <ul>
            <li> Ths is demo contate. yes kd jdk dkjlj lskjd kjkjdflj slkj.
            </li><li>This is another para
              </li>
          </ul>
      </div>
    </div>
  </div>

  <div class="row margin-bottom mb8 faq">
    <a  class="mapfre link collapse-link padding-horizontal ph40" (click)="closeNonActiveCollapse('two')" mdbRipple [class.active]="accordianWithMDB.two">
      <div class="row">
        <div class="col">{{ 'CLAIM_FAQ_4' | translate }}  </div>
        <div class="col collapse-carot text-right">
            <i class="fas fa-caret-down" *ngIf="!accordianWithMDB.two"></i>
            <i class="fas fa-caret-up" *ngIf="accordianWithMDB.two"></i>
          </div>
        </div>
    </a>
    <div class="row collapse-content padding-horizontal ph40" #two  [class.fake-accourdian]="!accordianWithMDB.two">
      <div class="padding-horizontal ph16 w-100">
          {{ 'CLAIM_FAQ_5' | translate }} 
          <a href="https://www.mapfreinsurance.com/en/claims/auto/" class="underline" target="_blank" rel="noopener">{{ 'SEE_OUR_HELP_SECTION' | translate }}</a> {{ 'CLAIM_FAQ_5B' | translate }} 
      </div>
    </div>
  </div>

  <div class="row margin-bottom mb8 faq">
    <a  class="mapfre link collapse-link padding-horizontal ph40" (click)=" closeNonActiveCollapse('three')" mdbRipple [class.active]="accordianWithMDB.three">
      <div class="row">
        <div class="col">{{ 'CLAIM_FAQ_6' | translate }}</div>
        <div class="col collapse-carot text-right">
          <i class="fas fa-caret-down" *ngIf="!accordianWithMDB.three"></i>
          <i class="fas fa-caret-up" *ngIf="accordianWithMDB.three"></i>
        </div>
      </div>
    </a>
    <div class="row collapse-content padding-horizontal ph40" #three [class.fake-accourdian]="!accordianWithMDB.three">
      <div class="padding-horizontal ph16 w-100">
          {{ 'CLAIM_FAQ_7' | translate }}
        </div>
    </div>
  </div>

  <div class="row margin-bottom mb8 faq">
    <a  class="mapfre link collapse-link padding-horizontal ph40" (click)=" closeNonActiveCollapse('four')" mdbRipple [class.active]="accordianWithMDB.four">
      <div class="row">
        <div class="col">{{ 'CLAIM_FAQ_8' | translate }} </div>
        <div class="col collapse-carot text-right">
          <i class="fas fa-caret-down" *ngIf="!accordianWithMDB.four"></i>
          <i class="fas fa-caret-up" *ngIf="accordianWithMDB.four"></i>
        </div>
      </div>
    </a>
    <div class="row collapse-content padding-horizontal ph40"  #four [class.fake-accourdian]="!accordianWithMDB.four">
      <div class="padding-horizontal ph16 w-100">
          {{ 'CLAIM_FAQ_9' | translate }}
        </div>
    </div>
  </div>

  <div class="row margin-bottom mb8 faq">
    <a  class="mapfre link collapse-link padding-horizontal ph40" (click)=" closeNonActiveCollapse('five')" mdbRipple [class.active]="accordianWithMDB.five">
      <div class="row">
        <div class="col">{{ 'CLAIM_FAQ_10' | translate }} </div>
        <div class="col collapse-carot text-right">
          <i class="fas fa-caret-down" *ngIf="!accordianWithMDB.five"></i>
          <i class="fas fa-caret-up" *ngIf="accordianWithMDB.five"></i>
        </div>
      </div>
    </a>
    <div class="row collapse-content padding-horizontal ph40" #five [class.fake-accourdian]="!accordianWithMDB.five">
      <div class="padding-horizontal ph16 w-100">
          {{ 'CLAIM_FAQ_11' | translate }}
        </div>
    </div>
  </div>

  <div class="row margin-bottom mb8 faq">
    <a  class="mapfre link collapse-link padding-horizontal ph40" (click)=" closeNonActiveCollapse('six')" mdbRipple [class.active]="accordianWithMDB.six">
      <div class="row">
        <div class="col">{{ 'CLAIM_FAQ_12' | translate }} </div>
        <div class="col collapse-carot text-right">
          <i class="fas fa-caret-down" *ngIf="!accordianWithMDB.six"></i>
          <i class="fas fa-caret-up" *ngIf="accordianWithMDB.six"></i>
        </div>
      </div>
    </a>
    <div class="row collapse-content padding-horizontal ph40" #six [class.fake-accourdian]="!accordianWithMDB.six">
      <div class="padding-horizontal ph16 w-100">
          {{ 'CLAIM_FAQ_13' | translate }}
        </div>
    </div>
  </div>
</section>
